import { render, staticRenderFns } from "./PlotDetail.vue?vue&type=template&id=4bc13343"
import script from "./PlotDetail.vue?vue&type=script&lang=js"
export * from "./PlotDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports